export const opacity = {
    full: 1,
    half: 0.5,
    zero: 0
}

export const GlobalStyles = {
    opacity
}

export const framerMotionAnimation = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  transition: {
    duration: 1,
  },
};

export const fontSizes = {
  xs: '12px',
  sm: '14px',
  base: '16px',
  lg: '18px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '30px',
};

export const transitions = {
  fast: '0.2s',
  slow: '0.5s',
};

// Page transition variants for framer-motion
export const pageVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

export const pageTransition = {
  duration: 0.3,
  ease: 'easeInOut',
};